export enum PaymentOptionsEnum {
  X = 'Neurčeno',
  M = 'Poštovní poukázkou',
  B = 'Bankovním převodem',
}
